import DatosPaciente from "./DatosPaciente";
export default DatosPaciente;